var exports = {
  "kL": "xdbfd91f1--c06855--container",
  "OB": "xdbfd91f1--c06855--empty_container",
  "LN": "xdbfd91f1--c06855--title_wrapper",
  "l7": "xdbfd91f1--c06855--all_offers_link",
  "DD": "xdbfd91f1--c06855--title",
  "C7": "xdbfd91f1--c06855--tab_links",
  "VS": "xdbfd91f1--c06855--tab_link",
  "rx": "xdbfd91f1--c06855--tab_link--active",
  "sC": "xdbfd91f1--c06855--tab_content",
};

module.exports = exports;
